export default __webpack_public_path__ + "static/media/logo-sicc-pt-br.a1753efe.png";